
import { theme } from "src/styles/theme";
import { styled } from "styled-components";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SectionTitle = styled.h2`
    font-family: ${theme.fonts.primary};
    font-weight: ${theme.fontWeights.semiBold};
    font-size: ${theme.fontSizes.md};
    line-height: 135%;
    letter-spacing: 0%;

`;

const Card = styled.div<{height?: string}>`
  background-color: #fff;
  border-radius: 10px;
  padding: 12px 16px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  border: 1px solid #0000001F;
  height: ${props=>props.height || 'auto'}
`;

const WordCountRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Label = styled.div`
  font-family: ${theme.fonts.secondary};
    font-weight: ${theme.fontWeights.semiBold};
    font-size: ${theme.fontSizes.base};
    line-height: 135%;
    letter-spacing: 0%;

`;

const Value = styled.div`
  font-family: ${theme.fonts.secondary};
    font-weight: ${theme.fontWeights.semiBold};
    font-size: ${theme.fontSizes.xl};
`;

const StatsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
`;

const StatsLabel = styled.div`
  font-family: ${theme.fonts.primary};
font-weight: ${theme.fontWeights.medium};
font-size: ${theme.fontSizes.md};
line-height: 100%;
letter-spacing: 0%;

`;

const StatsValue = styled.div`
  display: flex;
  align-items: center;
`;

const StatsText = styled.span`
  font-family: ${theme.fonts.secondary};
font-weight: ${theme.fontWeights.bold};
font-size: ${theme.fontSizes.lg};
    line-height: 100%;
    letter-spacing: 0%;

  margin-right: 10px;
  color: var(--Grey-4F4F4F, #4F4F4F);

`;

const StatsPercentage = styled.span`
  font-family: ${theme.fonts.primary};
font-weight: ${theme.fontWeights.medium};
font-size: ${theme.fontSizes.md};
    line-height: 100%;
    letter-spacing: 0%;
color: var(--Grey-4F4F4F, #4F4F4F);

`;

const ColorBox = styled.div<{ color: string }>`
  width: 24px;
  height: 24px;
  background-color: ${props => props.color};
  border-radius: 4px;
  margin-left: 10px;
`;

const DonutChart = styled.div<{from:number}>`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: conic-gradient(
    #8080ff 0% ${props => props.from}%,
    #e0e0ff ${props => props.from}% 100%
  );
  position: relative;
  margin-right: 20px;
  
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60px;
    height: 60px;
    background-color: white;
    border-radius: 50%;
  }
`;

const SubLabel = styled.div`
  font-family: ${theme.fonts.primary};
font-weight: ${theme.fontWeights.regular};
font-size: ${theme.fontSizes.md};
    line-height: 135%;
    letter-spacing: 0%;

  margin-bottom: 10px;

  color: var(--Grey-9E9E9E, #9E9E9E);

`;

interface QcastAnalyticsProps {
    wordCount: number;
    questionsAnswered: number;
    totalQuestions: number;
    clarityScore: number;
}
const Analytics: React.FC<QcastAnalyticsProps>= ({wordCount, questionsAnswered, totalQuestions, clarityScore}) => {
    const answeredPercentage = Math.round((questionsAnswered / totalQuestions) * 100);
    const unansweredPercentage = 100 - answeredPercentage;

    return (
        <Container>
            <Section>
                <SectionTitle>Word Count</SectionTitle>
                <Card height={"59px"}>
                    <WordCountRow>
                        <Label>Total</Label>
                        <Value>{wordCount}</Value>
                    </WordCountRow>
                </Card>
            </Section>

            <Section>
                <SectionTitle>Questions Answered</SectionTitle>
                <Card>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <DonutChart from={answeredPercentage} />
                    <div style={{ flex: 1 }}>
                    <StatsRow>
                        <StatsLabel>Answered</StatsLabel>
                        <StatsValue>
                        <StatsText>{questionsAnswered}/{totalQuestions}</StatsText>
                        <StatsPercentage>({answeredPercentage}%)</StatsPercentage>
                        <ColorBox color="#8080ff" />
                        </StatsValue>
                    </StatsRow>
                    <StatsRow>
                        <StatsLabel>Unanswered</StatsLabel>
                        <StatsValue>
                        <StatsText>{totalQuestions - questionsAnswered}/{totalQuestions}</StatsText>
                        <StatsPercentage>({unansweredPercentage}%)</StatsPercentage>
                        <ColorBox color="#e0e0ff" />
                        </StatsValue>
                    </StatsRow>
                    </div>
                </div>
                </Card>
            </Section>

            {/* <Section>
                <SectionTitle>Clarity of Response</SectionTitle>
                <SubLabel>Based on voice clarity and sentence structure</SubLabel>
                <Card>
                <WordCountRow>
                    <Label>Overall Score (1-10):</Label>
                    <Value>{clarityScore}</Value>
                </WordCountRow>
                </Card>
            </Section> */}
        </Container>
    )
}   

export default Analytics;